<div class="off-canvas" [class.open]="isOpen" style="overflow-y: auto; height: 100%">
	<ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</div>
